import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { IllustrationName } from "Constants/constants";

export const getIllustration = (
  product: ProductBackendName,
): IllustrationName | undefined => {
  switch (product) {
    case ProductBackendName.ADVICE:
      return IllustrationName.SAFETY_SECURITY;
    case ProductBackendName.CAR:
    case ProductBackendName.TRACTOR:
    case ProductBackendName.VETERAN_AUTO:
    case ProductBackendName.ELECTRIC_SCOOTER:
    case ProductBackendName.CHILD:
      return undefined;
    default:
      return IllustrationName.ESTABLISHMENT_FAMILY;
  }
};
